import React from 'react'
import { useAuctionTarget } from './hooks'
import Timer from './timer'

export default function AuctionTimerController({
    firstCloseIso,
    intervalMinutes,
    lotCount,
    dateAdded,
    theme,
    endText,
    startText,
    endingItems,
}) {
    const { targetDate, targetIndex } = useAuctionTarget(
        firstCloseIso,
        intervalMinutes,
        lotCount,
        endingItems,
        {
            tickMs: 1000,
            returnMoment: false,
        },
    )

    return (
        <div className="aucTimerWithInterval">
            <Timer
                date_closed={targetDate}
                date_added={dateAdded}
                theme={theme}
                endText={endText}
                startText={startText}
            />
        </div>
    )
}
